import {useEffect, useState} from "react";

export function useTruncatedText(text, max, onlyMobile = true) {
    const [truncated, setTruncated] = useState(text);

    useEffect(() => {
        const updateText = () => {
            const isMobile = window.innerWidth <= 768;
            if (onlyMobile) {
            setTruncated(isMobile && text.length > max ? `${text.substring(0, max)}...` : text);
            } else {
                setTruncated(text.length > max ? `${text.substring(0, max)}...` : text)
            }
        };

        window.addEventListener("resize", updateText);
        updateText(); // Initial check

        return () => window.removeEventListener("resize", updateText);
    }, [text, max]);

    return truncated;
}